<script>
    import { createEventDispatcher } from 'svelte';
    import Fa from 'svelte-fa'
    import { faAdd } from '@fortawesome/free-solid-svg-icons'
    
    const dispatch = createEventDispatcher();

    function clickExecuted() {
        dispatch('clicked', {
            
        });
    }
</script>

<div class="IconAdd" on:click={clickExecuted}>
    <Fa icon={faAdd} />
</div>

<style>
    .IconAdd {
        cursor: pointer;
        color: green;
    }
</style>